import { render, staticRenderFns } from "./CampanhaManualExecutivo.vue?vue&type=template&id=e770aab2"
import script from "./CampanhaManualExecutivo.vue?vue&type=script&lang=js"
export * from "./CampanhaManualExecutivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports